type Lock = { release(): Promise<void> };

/**
 * Best-effort screen wake lock, re-acquired whenever the tab becomes visible again
 * (browsers drop it on hide). Returns a release function; use from onMount.
 */
export function holdWakeLock(): () => void {
  let lock: Lock | null = null;
  let gone = false;
  async function acquire() {
    try {
      const wl = (navigator as Navigator & { wakeLock?: { request(t: 'screen'): Promise<Lock> } }).wakeLock;
      if (!wl || gone) return;
      const got = await wl.request('screen');
      if (gone) { void got.release().catch(() => {}); return; }
      lock = got;
    } catch { /* best effort */ }
  }
  const onVis = () => { if (document.visibilityState === 'visible') void acquire(); };
  void acquire();
  document.addEventListener('visibilitychange', onVis);
  return () => {
    gone = true;
    document.removeEventListener('visibilitychange', onVis);
    void lock?.release().catch(() => {});
  };
}
